import { FormControl, FormLabel } from '@mui/material'
import React from 'react'

import { UFormControlInputProps } from './type'
import { UInput } from '../u-input'
import { UStack } from '../u-stack'
import { UText } from '../u-text'

export const UFormControlInput = ({
  htmlFor,
  label,
  labelSuffix,
  required,
  uInputProps,
  error,
  fullWidth,
}: UFormControlInputProps) => {
  return (
    <FormControl error={error} fullWidth={fullWidth}>
      {label && (
        <UStack
          direction="row"
          alignItems="center"
          className="mb-1"
          spacing="2px"
        >
          <FormLabel htmlFor={htmlFor}>{label}</FormLabel>
          {required && (
            <UText variant="body2" color="error.main" className="line-height-1">
              *
            </UText>
          )}
          {labelSuffix}
        </UStack>
      )}
      <UInput
        id={htmlFor}
        error={error}
        fullWidth={fullWidth}
        {...uInputProps}
      />
    </FormControl>
  )
}
